import MDBox from "components/MDBox"
import MDButton from "components/MDButton";
import TableSkeleton from "components/TableSkeleton";
import { useEffect, useMemo, useState } from "react"
import { useMaterialUIController, setLoading } from "context";
import { useForm } from "react-hook-form";
import DataTable from "examples/Tables/DataTable";
import permissions from "permissions";
import { CircularProgress } from "@mui/material";
import { KanbanAPI } from "api/KanbanAPI";
import { CSVLink } from 'react-csv';
import { Box, Button } from '@mui/material';
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";


export default function OrderMasterWithoutEPTable(props) {

  // const [orderMaster, setOrderMaster] = useState([]);
  const { orderMaster, productType, setProductType } = props;
  const [controller, dispatch] = useMaterialUIController();
  const { user, loading, admin } = controller;
  const { handleSubmit, formState: { isSubmitting } } = useForm();
  const { handleAlert } = props
  // const [productType, setProductType] = useState("ALL");

  const currencyformatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
  });

  const numberFormater = new Intl.NumberFormat();
  const filteredOrderMaster = useMemo(() => {
    if (productType === "FINISHED") {
      return orderMaster.filter(item => item.codigo?.startsWith("5"));
    }

    if (productType === "IN_PROCESS") {
      return orderMaster.filter(item => !item.codigo?.startsWith("5"));
    }

    return orderMaster;
  }, [orderMaster, productType]); 

  const renderOrderMaster = useMemo(() => {
    let rows = [];
    const columns = [
      { Header: "Código", accessor: "codigo", align: "right" },
      { Header: "Cantidad Pendiente", accessor: "cantidad", align: "right", },
      { Header: "Valor Unitario", accessor: "valor_unitario", align: "right" },
      { Header: "Valor Total", accessor: "valor_total", align: "right" },
    ];

    filteredOrderMaster?.map((element) => {
      rows = [...rows,
      {
        codigo: element.codigo,
        cantidad: element.cantidad,
        valor_unitario: currencyformatter.format(Number(element.valor_unitario).toFixed(2)),
        valor_total: currencyformatter.format(Number(element.valor_total).toFixed(2)),
      }]
    });

     // Botones de exportación
     const exportButtons = (
      <Box display="flex" justifyContent="right" alignItems="right" marginBottom={2}>
      <Button variant="contained" color="primary" style={{ marginRight: '10px' }}>
        <CSVLink data={filteredOrderMaster} filename={'PT sin estructura MP.csv'} style={{ color: 'white', textDecoration: 'none' }}>
          Exportar CSV
        </CSVLink>
      </Button>
      {/* Otros botones de exportación, como PDF, Excel, etc. */}
    </Box>
    );

    return (
      <>
        <DataTable
          table={{ columns, rows }}
          isSorted={true}
          entriesPerPage={true}
          showTotalEntries={true}
          noEndBorder
          canSearch={true}
        />
        {exportButtons}
      </>
    );
  }, [filteredOrderMaster])


  // const getOrderMaster = () => {
  //   setLoading(dispatch, true)
    
  //   return KanbanAPI.order()
  //     .then(response => {
  //       setOrderMaster(response.data)
  //     }).catch(error => {
  //       if (error.response) {
  //         handleAlert(error.response.data.message, 'error')
  //       }
  //     }).finally(() => {
  //       setLoading(dispatch, false)
  //     });
  // }


  return (
  <MDBox>
    {/* FORMULARIO */}
    <MDBox
      component="form"
      role="form"
      // onSubmit={handleSubmit(getOrderMaster)}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: 3,
      }}
    >
    <FormControl
      sx={{
        minWidth: 220,
        '& .MuiInputBase-root': {
          height: 48,
        },
      }}
    >
      <InputLabel>Tipo de producto</InputLabel>
      <Select
        value={productType}
        label="Tipo de producto"
        onChange={(e) => setProductType(e.target.value)}
      >
        <MenuItem value="ALL">Todos</MenuItem>
        <MenuItem value="FINISHED">Productos terminados</MenuItem>
        <MenuItem value="IN_PROCESS">Productos en proceso</MenuItem>
      </Select>
    </FormControl>
{/* 
      {(user?.permissions?.includes(permissions.product_arrays[1]) || user?.role === admin) && (
        <MDButton type="submit" variant="gradient" color="info" disabled={isSubmitting}>
          {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Consultar Maestro Pedidos'}
        </MDButton>
      )} */}
    </MDBox>

    {/* TABLA */}
    <MDBox>
      {loading ? <TableSkeleton /> : renderOrderMaster}
    </MDBox>
  </MDBox>
);


}